export default __webpack_public_path__ + "cb2384cfa7a55ad10e55b66b305c1080.svg";